import type { EnhancedCellValue, TableRowType, TableColumnType } from '../../../grid/reduxStore/table.types.ts';

export function normalizeRowCellValues(row: TableRowType, columns: TableColumnType[]): TableRowType {
  const normalized = { ...row };
  columns.forEach((col) => {
    const val = normalized[col.field];
    if (typeof val === 'object' && val !== null && 'value' in val) {
      normalized[col.field] = (val as EnhancedCellValue).value;
    }
  });
  return normalized;
}
